import React, { useEffect, useState } from 'react';
import Input from '../Inputs/Input';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import { CollectionItemProps } from './Types/CollectionItem';
import { CollectionStoreActions } from '../../Reducers/CollectionStore.reducer';
import { translate } from '../../Services/translation';

const CollectionStoreInput = () => {
  const { collectionItems } = useTypedSelector(
    (state) => state.CollectionStoreReducer
  );

  const [collectionItem, setCollectionItem] =
    useState<CollectionItemProps>();

  const dispatch = useDispatch();

  const onChange = (value) => {
    setCollectionItem(undefined); //reset collectionItem onChange

    collectionItems.map((item) => {
      if (item.name.toLowerCase() == value) {
        setCollectionItem(item);
      }
    });
  };

  useEffect(() => {
    dispatch(
      CollectionStoreActions.setCollectionItem({
        item: collectionItem!,
      })
    );
  }, [dispatch, collectionItem]);

  return (
    <Input
      onChange={(e) => onChange(e.target.value.toLowerCase())}
      className=" w-full bg-gray-100 p-4"
      icon="search"
      inputSize="large"
      placeholder={translate('general.search')}
    />
  );
};

export default CollectionStoreInput;
